module.exports = __webpack_public_path__ + "img/complete.ddbe5a4.png";